import React, { useMemo } from 'react';
import { CountBadge } from '@europrocurement/flexy-components';
import { useDossierTasksContext } from '../../../providers/DossierTasksProvider';

const DossierTasksTabTitle: React.FunctionComponent = function () {
    const { orderedTasks } = useDossierTasksContext();

    const tasks = useMemo(
        () => orderedTasks.filter((task) => task.tache?.isDone === false),
        [orderedTasks],
    );

    // Update badgeColor based on expired undone tasks
    const badgeColor = useMemo(() => {
        const now = new Date();
        const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const tomorrowStart = new Date(todayStart);
        tomorrowStart.setDate(tomorrowStart.getDate() + 1);

        const hasExpired = tasks.some((task) => {
            if (!task.tache?.expiredAt) return false;
            return new Date(task.tache.expiredAt) < todayStart;
        });

        if (hasExpired) return 'error' as const;

        const hasToday = tasks.some((task) => {
            if (!task.tache?.expiredAt) return false;
            const d = new Date(task.tache.expiredAt);
            return d >= todayStart && d < tomorrowStart;
        });

        return hasToday ? ('warning' as const) : ('primary' as const);
    }, [tasks]);

    return (
        <CountBadge
            count={tasks.length}
            color={badgeColor}
            bgVariant="light"
        />
    );
};

export default DossierTasksTabTitle;
